module.exports = __webpack_public_path__ + "static/media/audio-call.e575985b.svg";